import React from 'react';
import { Card, Table } from 'react-bootstrap';

const money = (n) => new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(n || 0);

const STATUS_LABELS = {
  draft: 'Borrador',
  sent: 'Enviada',
  accepted: 'Aceptada',
  rejected: 'Rechazada',
  expired: 'Expirada',
};

const CotizacionesTab = ({ quotesStatus }) => {
  const rows = quotesStatus?.rows || [];
  const totalCount = rows.reduce((sum, r) => sum + r.count, 0);

  return (
    <div className="mt-3">
      <Card className="shadow-sm p-3">
        <Card.Title>Cotizaciones por Estado</Card.Title>
        <Table hover size="sm" className="mb-0">
          <thead><tr><th>Estado</th><th className="text-end"># Cotizaciones</th><th className="text-end">Valor Total</th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{STATUS_LABELS[r.status] || r.status}</td>
                <td className="text-end">{r.count}</td>
                <td className="text-end">{money(r.total)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={3} className="text-muted text-center">Sin cotizaciones en este rango.</td></tr>}
          </tbody>
          {totalCount > 0 && (
            <tfoot>
              <tr style={{ fontWeight: 700, borderTop: '2px solid var(--mm-line)' }}>
                <td>Total</td>
                <td className="text-end">{totalCount}</td>
                <td className="text-end">{money(rows.reduce((sum, r) => sum + r.total, 0))}</td>
              </tr>
            </tfoot>
          )}
        </Table>
      </Card>
    </div>
  );
};

export default CotizacionesTab;
